import { Outlet } from "react-router-dom";

import Layout from "@layouts/VerticalLayout";
import navigation from "@src/navigation/vertical";

import admin from "@src/navigation/vertical/rbac/admin";
import user from "@src/navigation/vertical/rbac/user";
import guest from "@src/navigation/vertical/rbac/guest";

import { useSelector } from "react-redux";

const VerticalLayout = props => {
  const session = useSelector(state => state.session);

  return (
    <Layout
      menuData={[
        ...navigation,
        ...(session.account.role === "admin" ? admin : []),
        ...(session.account.role === "user" ? user : []),
        ...(session.account.role === "guest" ? guest : []),
      ]}
      {...props}
    >
      <Outlet />
    </Layout>
  );
};

export default VerticalLayout;
